import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
// utils

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  stats: null,
};

// TODO: stats
export const getStats = createAsyncThunk(
  "getStats/dashboard",
  async ({ enqueueSnackbar, params }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`collections/dashboard/stats`, {
        params,
      });

      return {
        enqueueSnackbar,
        data: response.data,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const authlice = createSlice({
  name: "stats",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getStats.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(getStats.fulfilled, (state, action) => {
      state.isLoading = false;
      state.stats = action.payload.data;
    });

    builder.addCase(getStats.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar &&
        action.payload.enqueueSnackbar(
          JSON.stringify(
            action.payload.error ||
              action.payload.error.errors ||
              action.payload.error.message
          ),
          {
            variant: "error",
          }
        );
    });
  },
});

export default authlice.reducer;
